<mat-drawer-container class="flex-auto h-100" [ngClass]="{'with-refresh-icon': isLIC}">
    <mat-drawer-content class="flex flex-col overflow-hidden">
        <form [formGroup]="consultationForm" class="overflow-auto h-100 position-relative">
            <button type="button" class="no-button refresh-pref-icon" (click)="refreshTemplates()" *ngIf="isLIC">
                <img aria-hidden="true" class="blue-refresh" matTooltip="Refresh Preferences settings" alt="Refresh"
                    [src]="cvaUI_url+ '/assets/icons/refresh-blue.svg'">
            </button>
            <mat-tab-group animationDuration="0ms" class="tab-view" mat-stretch-tabs="false" mat-align-tabs="start"
                [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabChanged($event)"
                [ngClass]="{'top-30':isLIC}">
                @if(tabs && tabs.length) {
                @for(tab of tabs; track trackByFn(tab);let i = $index){
                <mat-tab [disabled]="disableAllTabs && i !== selectedIndex">
                    @if(tab.title === TAB_ITEM.TRANSCRIPT){
                    <ng-template mat-tab-label>
                        <span class="tab-icon"><img [src]="cvaUI_url + '/assets/icons/notes-primary.svg'"
                                alt="record transcription" /></span>
                        <span class="tab-title" [class.active-tab]="selectedIndex === Tab.TRANSCRIPTION">
                            Transcripts
                        </span>
                    </ng-template>
                    <div class="main-content fade-in-out pb-80" [@fadeInOut]="isVisible ? 'visible' : 'hidden'">
                        <cva-record-transcription #tab2 [appointmentId]="appointment.uid"
                            [isTabActive]="i === selectedIndex" [appointmentRefId]="appointment.referenceId"
                            [patientId]="appointment.patient.referenceId" [hasDefaultTemplate]="hasDefaultTemplate()"
                            [DEFAULT_PREFERRED_TEMPLATE]="templateType" [transcription]="recordedTranscription"
                            (updateTabIndex)="addNewTab($event)" [control]="getFormControl('transcription')"
                            [noteTemplateListing]="noteTemplateListing" [vitals]="vitals"
                            (transcriptionChange)="onTranscriptionUpdate($event)"
                            (recordingStateChange)="onRecordingStateChange($event)"
                            [userConsentTaken]="appointment.patientConsent"
                            [liveTranscriptionEnabled]="liveTranscriptionEnabled"></cva-record-transcription>
                    </div>
                    }@else {
                    <ng-template mat-tab-label>
                        <span class="tab-icon"><img [src]="cvaUI_url + '/assets/icons/soap-notes-primary.svg'"
                                alt="SOAP-notes" /></span>
                        <span class="tab-title" [class.active-tab]="i === selectedIndex">
                            <span class="ellipsis-text"
                                [title]="tab.title + (tab.suffix ? '(' + tab.suffix + ')' : '')">{{
                                tab.title }}{{tab.suffix ? '('+ tab.suffix +')':''}}</span>
                        </span>
                    </ng-template>
                    <div class="main-content fade-in-out pb-80" [@fadeInOut]="isVisible ? 'visible' : 'hidden'">
                        <cva-soap-notes [appointment]="appointment" [templateType]="tab.identifier"
                            [selectedTemplate]="selectedTemplate" [noteTemplateListing]="noteTemplateListing"
                            [tabControl]="getFormControl(tab.controlName)" (approve)="handleApprove()"
                            (toggleTabDisable)="toggleTabsDisable($event)"
                            [vitals]="getFormControl(tab.controlName+'_user_input').value || []"
                            [disableApprove]="disableAllApproves" [tabIndex]="i" (saveForm)="persistValues()"
                            [isTabActive]="i === selectedIndex" [hasDefaultTemplate]="hasDefaultTemplate()"
                            [DEFAULT_PREFERRED_TEMPLATE]="templateType" (updateTabIndex)="addNewTab($event)"
                            [transcription]="recordedTranscription"></cva-soap-notes>
                    </div>
                    }
                </mat-tab>
                }
                }
            </mat-tab-group>
        </form>
    </mat-drawer-content>
    <mat-drawer class="w-full sm:w-90 border-0 tasks-content h-100" [autoFocus]="false" [position]="'end'"
        [mode]="drawerMode" [opened]="isDrawerOpened()" [position]="'end'">
        <div class="pt-3 h-100 d-flex flex-column bg-custom-lightgray overflow-hidden">
            <cva-consultation-recommendations [selectedRecommendation]="selectedRecommendation" class="h-100"
                [practitionerId]="appointment.practitioner.referenceId" [patientId]="appointment.patient.referenceId"
                [notesApproved]="disableAllApproves" [patientAge]="(appointment.patient.dateOfBirth | age) ?? ''"
                (closeDrawer)="selectedRecommendation = null"></cva-consultation-recommendations>
        </div>
    </mat-drawer>
</mat-drawer-container>
@if(tabs.length > 1){
<div class="drawer-toggle-panel position-fixed top-50 translate-middle-y d-flex flex-column gap-2 z-custom d-print-none"
    [ngClass]="isLIC ? 'start-0' : 'end-0'">
    @if(recommendations.MEDICATIONS) {
    <button type="button" (click)="toggleDrawer(recommendationType.Medication)" [ngClass]="{
        'active': selectedRecommendation === recommendationType.Medication,
        'blink': isDrawerIconBlinking[recommendationType.Medication],
        'btn-icon-compact': isLIC
        }" class="btn btn-icon shadow-sm border" aria-label="Medication" matTooltip="Medication">
        <img src="{{ cvaUI_url + '/assets/icons/medications.svg' }}" alt="Medication" class="icon-sm" />
    </button>
    }

    @if(recommendations.TASKS) {
    <button type="button" (click)="toggleDrawer(recommendationType.Task)" [ngClass]="{
        'blink': isDrawerIconBlinking[recommendationType.Task],
        'active': selectedRecommendation === recommendationType.Task,
        'btn-icon-compact': isLIC
        }" class="btn btn-icon shadow-sm border" aria-label="Tasks List" matTooltip="Tasks List">
        <img src="{{ cvaUI_url + '/assets/icons/tasks.svg' }}" alt="Tasks List" class="icon-sm" />
    </button>
    }

    @if(recommendations.CLASSIFICATIONS) {
    <button type="button" (click)="toggleDrawer(recommendationType.Classification)" [ngClass]="{
        'active': selectedRecommendation === recommendationType.Classification,
            'blink': isDrawerIconBlinking[recommendationType.Classification],
            'btn-icon-compact': isLIC
        }" class="btn btn-icon shadow-sm border" aria-label="Classification" matTooltip="Classification">
        <img src="{{ cvaUI_url + '/assets/icons/classification.svg' }}" alt="Classification" class="icon-sm" />
    </button>
    }

    @if(recommendations.ACC_ELIGIBILITY) {
    <button type="button" (click)="toggleDrawer(recommendationType.ACC_ELIGIBILITY)" [ngClass]="{
        'active': selectedRecommendation === recommendationType.ACC_ELIGIBILITY,
            'blink': isDrawerIconBlinking[recommendationType.ACC_ELIGIBILITY],
            'btn-icon-compact': isLIC
        }" class="btn btn-icon shadow-sm border" aria-label="ACC_ELIGIBILITY" matTooltip="ACC Eligibility">
        <img src="{{ cvaUI_url + '/assets/icons/acc-eligibility.svg' }}" alt="Classification" class="icon-sm" />
    </button>
    }
</div>

}